import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CLine extends BasicCPCLArg<CLine> {
  private width: number;
  private startX: number;
  private startY: number;
  private endX: number;
  private endY: number;
  private isSolidLine: boolean;
  constructor(options?: {
    /**
     * 边框线条宽度
     */
    width?: number
    /**
     * 左上角x坐标
     */
    startX?: number
    /**
     * 左上角y坐标
     */
    startY?: number
    /**
     * 右下角x坐标
     */
    endX?: number
    /**
     * 右下角y坐标
     */
    endY?: number
    /**
     * 实线:true  虚线:false
     */
    isSolidLine?: boolean
  }) {
    super();
    this.width = options?.width ?? 0;
    this.startX = options?.startX ?? 0;
    this.startY = options?.startY ?? 0;
    this.endX = options?.endX ?? 0;
    this.endY = options?.endY ?? 0;
    this.isSolidLine = options?.isSolidLine ?? true;
  }

  clause(): CommandClause {

    return CPCLCommand.with(this.header())
      .appendNumber(this.startX)
      .appendNumber(this.startY)
      .appendNumber(this.endX)
      .appendNumber(this.endY)
      .appendNumber(this.width)
      .clause();
  }

  header(): string {
    return this.isSolidLine ? 'LINE' : 'LPLINE';
  }
}



